import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { BoxSlotTemplateGroupScheduleForm } from "@modules/boxSlotTemplate/components/boxSlotTemplateGroupScheduleForm"
import { BoxSlotTemplateGroupSettingsForm } from "@modules/boxSlotTemplate/components/boxSlotTemplateGroupSettingsForm"
import { useBoxSlotTemplateGroupFormik } from "@modules/boxSlotTemplate/hooks/useBoxSlotTemplateGroupFormik"
import { word } from "@modules/core/utils/i18n"
import { useEffect, useState } from "react"

type Step = "Settings" | "Schedule"

type BoxSlotTemplateGroupFormProps = {
  boxProgramId: string
  className?: string
} & React.ComponentProps<"div">

export function BoxSlotTemplateGroupForm({ boxProgramId, className, ...props }: BoxSlotTemplateGroupFormProps) {
  const [formStep, setFormStep] = useState<Step>("Settings")
  const formik = useBoxSlotTemplateGroupFormik(boxProgramId)

  useEffect(() => {
    document.querySelector('[data-slot="right-sidebar-content"]')?.scrollTo({ top: 0 })
  }, [formStep])

  const moveToScheduleStep = async () => {
    const firstStepInputNames = [
      "limitStart",
      "limitEnd",
      "limitCancel",
      "slotDuration",
      "participantLimit",
      "location",
    ]
    firstStepInputNames.forEach((inputName) => void formik.setFieldTouched(inputName))

    const errors = await formik.validateForm()

    if (!Object.keys(errors).some((errorKey) => firstStepInputNames.indexOf(errorKey) >= 0)) setFormStep("Schedule")
  }

  return (
    <div className={cn("flex flex-col gap-4 px-5 pt-18 pb-6", className)} {...props}>
      <div className="flex flex-col gap-2.5">
        <Text fontStyle="TL" className="text-textDefault-heading">
          {word("box.slotTemplateGroup.form.title")}
        </Text>
        <Text fontStyle="BS">{word("box.slotTemplateGroup.form.subtitle")}</Text>
      </div>

      {formStep === "Settings" ? (
        <BoxSlotTemplateGroupSettingsForm formik={formik} moveToScheduleStep={() => void moveToScheduleStep()} />
      ) : (
        <BoxSlotTemplateGroupScheduleForm
          formik={formik}
          moveToSettingsStep={() => setFormStep("Settings")}
          submitForm={() => void formik.submitForm()}
          isSubmitting={formik.isSubmitting}
        />
      )}
    </div>
  )
}
